import React, { useState, ReactNode } from "react";

interface Tab {
  name: string;
  content: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
}

const TabBlockView: React.FC<TabsProps> = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  if (!tabs || tabs.length === 0) return null;

  return (
    <div style={styles.container}>
      {/* Tab buttons */}
      <div style={styles.tabButtons}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            style={{
              ...styles.tabButton,
              ...(activeIndex === index ? styles.activeTabButton : {}),
              ...(hoverIndex === index && activeIndex !== index ? styles.tabButtonHover : {}),
            }}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={styles.content}>{tabs[activeIndex].content}</div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: "100%",
  },
  tabButtons: {
    display: "flex",
    marginBottom: 0,
    border: "none",
  },
  tabButton: {
    padding: "0.5rem 3rem",
    cursor: "pointer",
    border: "none",
    backgroundColor: "#E6E6E6",
    fontWeight: 500,
    transition: "all 0.2s ease",
    outline: "none",
    fontSize:"1rem",
  },
  activeTabButton: {
    backgroundColor:"#A8A8A8",
    fontWeight: "bold",
  },
  tabButtonHover: {
    backgroundColor: "#E0E0E0",
  },
  content: {
    border: "5px solid #A8A8A8",
    borderRadius: "0 0 6px 6px",
    backgroundColor: "#fff",
    minHeight: 150,
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
  },
};

export default TabBlockView;